import { useState, useEffect } from 'react';
import { fetchProjects } from '@gp/services/projectDetail';

import type { IProjectDTO } from '@gp/types/projectDetail';

export default function useProjects() {
  const [projectsLoading, setProjectsLoading] = useState(true);

  const [projects, setProjects] = useState<IProjectDTO[]>([]);

  const initializeOptions = async () => {
    try {
      setProjectsLoading(true);
      const res = await fetchProjects({ search: '' });
      const resData = res?.data;
      const projectsTmp = !Array.isArray(resData) ? [] : resData;
      setProjects(projectsTmp);
    } catch (exception) {
      setProjects([]);
    } finally {
      setProjectsLoading(false);
    }
  };

  useEffect(() => {
    initializeOptions();
  }, []);

  return { projectsLoading, projects, projectsRefresh: initializeOptions };
}
